import { useTranslation } from 'react-i18next';

export function SkipLink() {
  const { t } = useTranslation();
  return (
    <a
      href="#main-content"
      className="bg-primary text-primary-foreground sr-only fixed left-2 top-2 z-50 rounded px-3 py-2 text-sm font-medium focus:not-sr-only focus:ring-2 focus:ring-offset-2"
    >
      {t('a11y.skip_to_content', 'Pular para conteudo')}
    </a>
  );
}
